import { render, staticRenderFns } from "./CreatePostSidebar.vue?vue&type=template&id=77f5e1de"
import script from "./CreatePostSidebar.vue?vue&type=script&lang=js"
export * from "./CreatePostSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports